import type { Filter, FilterDataOption, FilterDataMultiSelect } from '@/app/common/filters/core/filtersTypes.ts';
import { FILTER_TYPE } from '@/app/common/filters/core/filtersTypes.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { type TranslationDictionary } from '@/app/components/translations/createTranslationDictionary.ts';
import type { SimpleOptionCreate } from '@/app/common/filters/groups/filterGroupsUtils.ts';
import { simpleOptionCreator } from '@/app/common/filters/groups/filterGroupsUtils.ts';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';

const createLeisureTypeOptions = (simpleOptionCreate: SimpleOptionCreate): FilterDataOption[] => [
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.leisure.l4', value: 'L4' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.leisure.l1', value: 'L1' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.leisure.l2', value: 'L2' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.leisure.l3', value: 'L3' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.leisure.l5', value: 'L5' }),
];

type CreateLeisureTypeFilters = {
  searchParams: SearchParams;
  translationDictionary: TranslationDictionary;
};
export const createLeisureTypeFilters = ({
  searchParams,
  translationDictionary,
}: CreateLeisureTypeFilters): Filter[] => {
  const showLeisureTypeFilter = searchParams[URLParameters.DESTINATION] === 'A';
  const selectedValues = searchParams[URLParameters.LEISURE]?.split(',') || [];

  const simpleOptionCreate = simpleOptionCreator({ selectedValues, translationDictionary });

  const leisureTypeFilter: Filter | undefined = showLeisureTypeFilter
    ? {
        name: FILTER_NAME.LEISURE_TYPE,
        type: FILTER_TYPE.MULTI_SELECT,
        data: {
          options: createLeisureTypeOptions(simpleOptionCreate),
        } as FilterDataMultiSelect,
      }
    : undefined;

  return [...[leisureTypeFilter]].filter((f) => !!f);
};
